import { takeLatest } from 'redux-saga/effects';
import { handleAddEmail, handleVerifyEmail, handleResendOtpEmail } from './emailFormHandlers';
import { addEmail, verifyEmail, resendEmailOtp } from './emailFormSlice';

export function* addEmailSaga() {
  yield takeLatest(addEmail.type, handleAddEmail);
}

export function* verifyEmailSaga() {
  yield takeLatest(verifyEmail.type, handleVerifyEmail);
}

export function* resendOtpEmailSaga() {
  yield takeLatest(resendEmailOtp.type, handleResendOtpEmail);
}
